import MaterialTable from 'material-table';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { Link, useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Typography } from '@material-ui/core';
import apiService from '../../../services.js/apiService';
import { IsEmpty } from '../../../common/checks';

const GiveawayWinner = () => {
  const [openModal, setOpenModal] = useState(false);
  const [giveawayWinners, setGiveawayWinners] = useState([]);
  const [id, setId] = useState('');
  const history = useHistory();

  const handleOpenModal = (modalId) => {
    setOpenModal(true);
    setId(modalId);
  };

  const fetchData = async () => {
    try {
      const data = await apiService.getGiveAwayWinners();
      setGiveawayWinners(data || []);
    } catch (err) {
      toast.error(err.message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const onClickDelete = async (e) => {
    e.preventDefault();
    try {
      await apiService.deleteGiveAwayWinner(id);
      toast.success('Delete giveaway data Success');
      fetchData();
    } catch (err) {
      toast.error(err.message);
    }
    handleCloseModal();
  };

  return (
    <div>
      <div className="content-header d-flex align-items-center py-3">
        <Typography variant="h4" style={{ fontWeight: 'bold' }}>GiveAway Winners</Typography>
        <Link to="/admin/mobileApp/giveawayWinner/add">
          <Button variant="contained">Add Winner</Button>
        </Link>
      </div>
      <MaterialTable
        data={giveawayWinners}
        columns={[
          {
            title:     'Giveaway Entry Id',
            field:     'giveawayEntryId',
            cellStyle: {
              width: '25%',
            },
          },
          {
            title:     'Shooper Id',
            field:     'shopperId',
            cellStyle: {
              width: '5%',
            },
          },
          { title: 'Name', field: 'name' },
          { title: 'Mobile', field: 'mobile' },
          {
            title:  'Prize Sent Date',
            field:  'prizeSentDate',
            render: (item) => (!IsEmpty(item.prizeSentDate) ? item.prizeSentDate : '-'),
          },
          {
            title:  'Win Date',
            field:  'winDate',
            render: (item) => (!IsEmpty(item.winDate) ? item.winDate : '-'),
          },
        ]}
        actions={[
          {
            icon:    'edit',
            tooltip: 'View/Edit Winner',
            onClick: (event, giveawayWiner) => {
              history.push(`/admin/mobileApp/giveawayWinner/${giveawayWiner.id}`);
            },
          },
          {
            icon:    'delete',
            tooltip: 'Delete Winner',
            onClick: (event, giveawayWiner) => {
              handleOpenModal(giveawayWiner.id);
            },
          },
        ]}
        localization={{ toolbar: { searchPlaceholder: 'Search winners' } }}
        options={{
          actionsColumnIndex: -1,
          search:             true,
          showTitle:          false,
          filtering:          true,
          sorting:            true,
        }}
      />
      <Dialog
        fullWidth
        size="sm"
        open={openModal}
        onClose={handleCloseModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete giveaway winner</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this giveaway winner?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal} color="primary">Cancel</Button>
          <Button onClick={(e) => { onClickDelete(e); }} color="secondary">Delete</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default connect(null, null)(GiveawayWinner);
